module.exports = __webpack_public_path__ + "static/company-hero-dfd0531886f551853c584e0b454c096b.png";